var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-list"},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.active,"mode":"vertical","unique-opened":_vm.uniqueOpened},on:{"select":_vm.handleSelect}},[_c('menu-item',{attrs:{"routes":_vm.routes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }